<template>
    <div class="container">
        <div @click="goback" style="font-size: 14px; margin-bottom: 10px; cursor: pointer; width: 50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form :model="form" :rules="rules" ref="form" class="package-form">
            <el-form-item label="套餐名称" prop="name" label-width="250px">
                <el-input v-model="form.name" autocomplete="off" :disabled="edit"></el-input>
            </el-form-item>
            <el-form-item label="套餐时长" class="packtime" prop="time" label-width="250px">
                <el-input-number v-model="form.time" :min="1" :disabled="edit"></el-input-number>
                <el-select v-model="form.time_unit" :disabled="edit">
                    <el-option label="DAY" value="DAY"></el-option>
                    <el-option label="WEEK" value="WEEK"></el-option>
                    <el-option label="MONTH" value="MONTH"></el-option>
                    <el-option label="YEAR" value="YEAR"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐价格/套餐售价/币种" prop="prices" label-width="250px">
                <div v-for="(v, i) in form.prices" :key="i" class="packcurrency">
                    <el-input v-model="v.price" autocomplete="off" placeholder="套餐价格"></el-input>
                    <el-input v-model="v.sale_price" autocomplete="off" placeholder="套餐售价"></el-input>
                    <el-select v-model="v.currency" placeholder="币种">
                        <el-option v-for="item in currencyList" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                    <div v-if="i === form.prices.length - 1">
                        <span style="font-size: 24px; color: rgb(64, 158, 255); cursor: pointer; margin-right: 2px"
                            @click="addCurrency">
                            <i class="el-icon-circle-plus"></i>
                        </span>
                        <span style="font-size: 24px; color: #f56c6c; cursor: pointer" @click="subtractCurrency(i)"
                            v-if="form.prices.length > 1">
                            <i class="el-icon-remove"></i>
                        </span>
                    </div>
                    <div v-else style="font-size: 24px; color: #f56c6c; cursor: pointer" @click="subtractCurrency(i)">
                        <i class="el-icon-remove"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="套餐类型" label-width="250px" prop="data_type">
                <el-select v-model="form.data_type" :disabled="edit">
                    <el-option label="周期套餐" :value="0"> </el-option>
                    <el-option label="畅享套餐" :value="1"> </el-option>
                    <el-option label="加油包" :value="2"> </el-option>
                    <el-option label="免费试用套餐" :value="3"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐流量限制" prop="data_limit" label-width="250px">
                <el-input-number v-model="form.data_limit" :disabled="edit"></el-input-number><span
                    style="margin-left: 4px">KB</span>
            </el-form-item>
            <el-form-item label="使用优先级" prop="user_priority" label-width="250px">
                <el-input-number v-model="form.user_priority" :disabled="edit"></el-input-number>
            </el-form-item>
            <el-form-item label="最受欢迎" label-width="250px" prop="most_popular">
                <el-select v-model="form.most_popular" :disabled="edit">
                    <el-option label="否" :value="0"> </el-option>
                    <el-option label="是" :value="1"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="vsim套餐id" prop="pkg_type_id" label-width="250px">
                <el-input v-model="form.pkg_type_id" autocomplete="off" :disabled="edit"></el-input>
            </el-form-item>
            <el-form-item label="区域" prop="region" label-width="250px">
                <el-select v-model="form.region" multiple>
                    <el-option label="cn" value="cn"></el-option>
                    <el-option label="eu" value="eu"></el-option>
                    <el-option label="us" value="us"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="附加功能" label-width="250px">
                <div class="feature-list">
                    <div v-for="(item, index) in form.ext_features" :key="item.id || index" class="feature-row">
                        <el-select v-model="item.item_key" class="feature-key-select" filterable placeholder="选择功能项"
                            @change="onFeatureKeyChange(item)">
                            <el-option v-for="feature in featureOptions" :key="feature.item_key"
                                :label="feature.item_name + '（' + feature.item_key + '）'"
                                :value="feature.item_key"></el-option>
                        </el-select>
                        <el-select v-if="item.item_key === '4g_package'" v-model="item.item_value"
                            class="feature-value-control" filterable clearable placeholder="选择4G套餐">
                            <el-option v-for="pack in fourGPackageOptions" :key="pack.code"
                                :label="pack.name + '（' + pack.code + '）'" :value="pack.code"></el-option>
                        </el-select>
                        <el-select v-else-if="item.item_key === 'cloud_storage'" v-model="item.item_value"
                            class="feature-value-control" filterable clearable placeholder="选择云存储套餐">
                            <el-option v-for="pack in cloudPackageOptions" :key="pack.code"
                                :label="pack.name + '（' + pack.code + '）'" :value="pack.code"></el-option>
                        </el-select>
                        <el-input v-else v-model.trim="item.item_value" class="feature-value-control"
                            placeholder="功能值（可选）"></el-input>
                        <el-input-number v-model="item.sort_order" class="feature-sort-order" :min="0" :precision="0"
                            controls-position="right"></el-input-number>
                        <el-button type="danger" size="mini" @click="removeFeature(index)">删除</el-button>
                    </div>
                    <el-button type="primary" plain size="small" @click="addFeature">添加附加功能</el-button>
                    <div class="help-text">4g_package 的值请选择 4G 套餐，cloud_storage 的值请选择云存储套餐；其余功能项直接填写功能值。功能项按排序值升序展示。</div>
                </div>
            </el-form-item>
            <el-form-item label="" label-width="250px">
                <el-button type="primary" v-if="!edit" :loading="submitting" @click="Validate(addconfirm)">新增</el-button>
                <el-button type="primary" v-if="edit" :loading="submitting" @click="Validate(editconfirm)">修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script type="text/ecmascript-6">
import api from "../../../axios/pack"
export default {
    name: "",
    mixins: [],
    components: {},
    props: {},
    data() {
        var checkPrices = (rule, value, callback) => {
            let isValid = 0
            for (let i = 0; i < value.length; i++) {
                const e = value[i]
                let reg = /^([1-9]\d*|0)(\.\d{1,2})?$/
                if (!e.price || !e.sale_price) {
                    isValid = 1
                } else if (!reg.test(+e.price) || !reg.test(+e.sale_price)) {
                    isValid = 2
                }
            }
            if (isValid === 1) {
                callback(new Error("不能为空"))
            } else if (isValid === 2) {
                callback(new Error("请输入整数或最多两位小数的数值型"))
            } else {
                callback()
            }
        }
        return {
            edit: false,
            packCode: "",
            title: "",
            submitting: false,
            originalFeatureIds: [],
            featureOptions: [],
            cloudPackageOptions: [],
            fourGPackageOptions: [],
            form: {
                name: "",
                time: 1,
                time_unit: "",
                data_type: 0,
                data_limit: 0,
                most_popular: 0,
                prices: [
                    {
                        sale_price: "",
                        price: "",
                        currency: "USD",
                    },
                ],
                region: [],
                user_priority: 100,
                pkg_type_id: "",
                ext_features: []
            },
            rules: {
                name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
                time: [{ required: true, message: "请输入套餐时长", trigger: "blur" }],
                time_unit: [
                    { required: true, message: "请输入时间单位", trigger: "blur" },
                ],
                prices: [{ required: true, validator: checkPrices, trigger: "blur" }],
                user_priority: [
                    { required: true, message: "请输入使用优先级", trigger: "blur" },
                ],
                data_limit: [
                    { required: true, message: "请选择套餐流量限制", trigger: "change" },
                ],
                data_type: [
                    { required: true, message: "请选择套餐类型", trigger: "change" },
                ],
                most_popular: [
                    { required: true, message: "请选择是否是最受欢迎", trigger: "change" },
                ],
                pkg_type_id: [
                    { required: true, message: "请输入vsim套餐id", trigger: "blur" },
                ],
                region: [
                    { required: true, message: "请选择区域", trigger: "change" },
                ],
            },
            currencyList: [],
        }
    },
    computed: {},
    watch: {},
    methods: {
        GetCurrency() {
            this.api
                .CurrencyList({
                    page: 1,
                    limit: 100,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.currencyList = res.data.data.data
                        return
                    }
                    this.$message.error("获取失败" + res.data.msg)
                })
        },
        GetFeatureOptions() {
            api.HuntingPackageFeatureDictAll({}).then((res) => {
                if (res.data.code == 200) {
                    this.featureOptions = res.data.data.data || []
                    return
                }
                this.$message.error("获取功能项字典失败" + res.data.msg)
            })
        },
        GetFourGPackageOptions() {
            api.FourGPackageList({
                page: 1,
                limit: 1000,
                status: JSON.stringify([0, 1, 2]),
                order_action: 1
            }).then((res) => {
                if (res.data.code == 200) {
                    const list = res.data.data.data || []
                    this.fourGPackageOptions = list.filter(item => item && item.code)
                    return
                }
                this.$message.error("获取4G套餐失败" + res.data.msg)
            })
        },
        GetCloudPackageOptions() {
            api.PackageList({
                page: 1,
                limit: 1000,
                status: JSON.stringify([0, 1, 2]),
                is_event: -1,
                order_action: 1
            }).then((res) => {
                if (res.data.code == 200) {
                    const list = res.data.data.data || []
                    this.cloudPackageOptions = list.map(item => item.SetMeal || item).filter(item => item && item.code)
                    return
                }
                this.$message.error("获取云存储套餐失败" + res.data.msg)
            })
        },
        GetInfo() {
            api.FourGPackageDetail({ code: this.packCode }).then((res) => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    const extFeatures = data.ext_features || []
                    this.form = {
                        ...data.info,
                        prices: data.price.map((v) => ({
                            sale_price: v.sale_price,
                            price: v.price,
                            currency: v.currency,
                        })),
                        region: data.region.map((v) => v.region),
                        ext_features: extFeatures.map(item => ({
                            id: item.id,
                            item_key: item.item_key,
                            item_value: item.item_value,
                            sort_order: item.sort_order
                        }))
                    }
                    this.originalFeatureIds = extFeatures.map(item => item.id)
                    return
                }
                this.$message.error("获取详情失败" + res.data.msg)
            })
        },
        Validate(call) {
            this.$refs.form.validate((valid) => {
                if (valid && this.validateFeatures() && call) {
                    call()
                }
            })
        },
        validateFeatures() {
            if (this.form.ext_features.some(item => !item.item_key)) {
                this.$message.error("请选择附加功能项")
                return false
            }
            if (this.form.ext_features.some(item => item.item_key === "4g_package" && !item.item_value)) {
                this.$message.error("请选择 4g_package 对应的 4G 套餐")
                return false
            }
            if (this.form.ext_features.some(item => item.item_key === "cloud_storage" && !item.item_value)) {
                this.$message.error("请选择 cloud_storage 对应的云存储套餐")
                return false
            }
            return true
        },
        addFeature() {
            this.form.ext_features.push({
                item_key: "",
                item_value: "",
                sort_order: this.form.ext_features.length
            })
        },
        removeFeature(index) {
            this.form.ext_features.splice(index, 1)
        },
        onFeatureKeyChange(item) {
            item.item_value = ""
        },
        normalizedFeatures() {
            return this.form.ext_features.map(item => ({
                item_key: item.item_key,
                item_value: item.item_value || "",
                sort_order: Number(item.sort_order) || 0
            }))
        },
        addconfirm() {
            this.createPack()
        },
        createPack() {
            this.submitting = true
            const payload = {
                name: this.form.name,
                time: +this.form.time,
                time_unit: this.form.time_unit,
                data_type: this.form.data_type,
                data_limit: this.form.data_limit,
                prices: this.form.prices.map(v => ({ ...v, sale_price: +v.sale_price, price: +v.price })),
                most_popular: this.form.most_popular,
                region: this.form.region,
                user_priority: this.form.user_priority,
                pkg_type_id: this.form.pkg_type_id
            }
            const extFeatures = this.normalizedFeatures()
            if (extFeatures.length) {
                payload.ext_features = extFeatures
            }
            api
                .FourGPackageCreate(payload)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.form = {}
                        this.showSuccessConfirm()
                        return
                    }
                    this.$message.error(this.title + "失败" + res.data.msg)
                })
                .finally(() => {
                    this.submitting = false
                })
        },
        update() {
            this.submitting = true
            api
                .FourGPackageUpdatePrice({
                    code: this.packCode,
                    prices: this.form.prices.map(v => ({ ...v, sale_price: +v.sale_price, price: +v.price })),
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.updateRegion()
                        return
                    }
                    this.submitting = false
                    this.$message.error(this.title + "失败" + res.data.msg)
                })
                .catch(() => {
                    this.submitting = false
                })
        },
        updateRegion() {
            api
                .FourGPackageUpdateRegion({
                    code: this.packCode,
                    region: this.form.region,
                })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.updateExtFeatures()
                            .then(() => {
                                this.form = {}
                                this.showSuccessConfirm()
                            })
                            .catch(error => {
                                this.$message.error(this.title + "附加功能失败" + error.message)
                            })
                            .finally(() => {
                                this.submitting = false
                            })
                        return
                    }
                    this.submitting = false
                    this.$message.error(this.title + "失败" + res.data.msg)
                })
                .catch(() => {
                    this.submitting = false
                })
        },
        updateExtFeatures() {
            const features = this.normalizedFeatures()
            if (features.length) {
                return api.FourGPackageExtFeaturesUpdate({
                    sim_data_package_code: this.packCode,
                    features: features
                }).then(res => {
                    if (res.data.code != 200) {
                        throw new Error(res.data.msg)
                    }
                })
            }
            if (!this.originalFeatureIds.length) {
                return Promise.resolve()
            }
            return Promise.all(this.originalFeatureIds.map(id => api.FourGPackageExtFeaturesDelete({ id })))
                .then(results => {
                    const failed = results.find(res => res.data.code != 200)
                    if (failed) {
                        throw new Error(failed.data.msg)
                    }
                })
        },
        showSuccessConfirm() {
            this.$confirm(this.title + "成功，是否返回列表页?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.goback()
            })
        },
        editconfirm() {
            this.update()
        },
        goback() {
            this.$router.push("/iot/4gpack")
        },
        subtractCurrency(i) {
            this.form.prices.splice(i, 1)
        },
        addCurrency() {
            this.form.prices.push({
                sale_price: "",
                price: "",
                currency: "USD",
            })
        },
    },
    filters: {},
    mounted() {
        this.packCode = this.$route.params.code
        if (this.packCode !== "0") {
            this.GetInfo()
            this.title = "修改"
            this.edit = true
        } else {
            this.title = "新增"
            this.edit = false
        }
    },
    created() {
        this.GetCurrency()
        this.GetFeatureOptions()
        this.GetCloudPackageOptions()
        this.GetFourGPackageOptions()
    },
}
</script>

<style scoped>
.package-form {
    width: 1000px;
}

.packtime :deep(.el-form-item__content) {
    display: flex;
}

.packcurrency,
.feature-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.packcurrency :deep(.el-select) {
    width: 120px;
    margin-right: 8px;
}

.packcurrency :deep(.el-input) {
    width: 100px;
    margin-right: 8px;
}

.feature-list {
    width: 720px;
}

.feature-row {
    gap: 8px;
}

.feature-key-select,
.feature-value-control {
    width: 240px;
}

.feature-sort-order {
    flex: 0 0 110px;
    width: 110px;
}

.feature-sort-order :deep(.el-input) {
    width: 100%;
}

.help-text {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
}
</style>
